import { ofType } from 'redux-observable';
import { tap, mapTo, throttleTime, ignoreElements } from 'rxjs/operators';

import { SEND_OTP_CODE } from 'modules/auth/actions/sendOtpCode';
import { EXTERNAL_LOGIN } from 'modules/auth/actions/externalLogin';
import { UPDATE_JWT_TOKEN, UPDATE_JWT_TOKEN_UNPOSSIBLE } from '../actions/updateJwtToken';
import { sessionInitialized } from '../selectors/sessionStatus';
import { addToast } from '../../messageSystem/actions/addToast';

export const jwtToken = action$ =>
  action$.pipe(
    ofType(
      SEND_OTP_CODE.success,
      UPDATE_JWT_TOKEN.success,
      EXTERNAL_LOGIN.success,
    ),
    tap(({ payload }) => {
      localStorage.setItem('jwt', payload.jwtToken);
    }),
    ignoreElements(),
  );

export const updateJwtUnpossible = action$ =>
  action$.pipe(
    ofType(UPDATE_JWT_TOKEN_UNPOSSIBLE),
    throttleTime(5000),
    mapTo((dispatch, getState) => {
      if (sessionInitialized(getState())) {
        return dispatch(addToast('failure', 'session-has-expired-toast', {
          id: 'const.error.incorrectVerificationToken',
          defaultMessage: '** Your session has expired. Please login again.',
        }));
      }
    }),
  );
